import styled from 'styled-components'
import { breakpoints } from '../../styles/media'

export const Row = styled.div`
    --layout-gutter-x: 1.5rem;
    --layout-gutter-y: 1rem;
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(-1 * var(--layout-gutter-y));
    margin-right: calc(-.5 * var(--layout-gutter-x));
    margin-left: calc(-.5 * var(--layout-gutter-x));
    width: ${({ $width }) => $width};
    justify-content: ${({ $hspacing }) => $hspacing};;


    & >* {
    flex-shrink: 0;
    width: 100%;
    max-width: 100%;
    padding-right: calc(var(--layout-gutter-x) * .5);
    padding-left: calc(var(--layout-gutter-x) * .5);
    margin-top: var(--layout-gutter-y);
    padding-block: ${({ $paddingBlock }) => $paddingBlock};
}
`
export const Container = styled.div`
    --layout-gutter-x: 1.5rem;
    --layout-gutter-y: 0;
    width: 100%;
    padding-right: calc(var(--layout-gutter-x) * .5);
    padding-left: calc(var(--layout-gutter-x) * .5);
    margin-right: auto;
    margin-left: auto;
    margin-top: ${({ $marginTop }) => $marginTop};
    margin-bottom: ${({ $marginBottom }) => $marginBottom};    
`

// Component has a optional prop.grow that determines if its growth is 0
export const Col = styled.div`
    display: flex;
    padding: ${({ $padding }) => $padding}; 
    @media (min-width: 576px) {
    flex: ${({ $flex }) => $flex}; 
    }
`

export const Line = styled.div`
    --line-gutter-x: 1.5rem;
    --line-gutter-y: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(-1 * var(--line-gutter-y));
    margin-right: calc(-.5 * var(--line-gutter-x));
    margin-left: calc(-.5 * var(--line-gutter-x));
`

export const Cell = styled.div`
    display: flex;
    padding: ${({ $padding }) => $padding}; 
    flex: ${({ $flex }) => $flex}; 
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
     @media (min-width: ${({ theme }) => theme.breakpoint.s}) {
        width: ${({ $width }) => $width ? $width : ''};
        /* Never wider than what holds it: a card title set to the card's
           width must not push its buttons out of a narrower panel. */
        max-width: 100%;
    }

`

export const RelativeWrapper = styled.div`
  position: relative;
  width: 100%;
`;



export const FlexBox = styled.div`
  display: flex;
  flex-wrap: ${({ $wrap }) => $wrap};;
  gap: ${({ $gap }) => $gap};
  flex: ${({ $flex }) => $flex};
  justify-content: ${({ $justify }) => $justify};
  align-items: ${({ $alignItems }) => $alignItems};
`

export const TextLine = styled.p`
    margin-top: ${({ $mt }) => $mt || '0rem'};
    margin-bottom: ${({ $mb }) => $mb || '0rem'};
    margin-right: ${({ $mr }) => $mr || '0rem'};
    margin-left: ${({ $ml }) => $ml || '0rem'};
    font-size: var(--font-XS);
    white-space: ${({ $wrap }) => $wrap || 'wrap'} 
`